import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// UX-6a A2: the one quiet stale-while-revalidate affordance, used everywhere. It
// shows ONLY during a background refetch (data already on screen) — never on the
// first load (that is the skeleton's job). A small muted line with a soft gold
// pulse; unobtrusive, honest that fresher data is on the way.
export function UpdatingIndicator({ active, className }) {
  const { t } = useTranslation();
  if (!active) return null;
  return (
    <span
      data-testid="updating-indicator"
      role="status"
      aria-live="polite"
      className={classNames("inline-flex items-center gap-1.5 text-xs text-slate-400", className)}
    >
      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-gold" aria-hidden="true" />
      {t("common.updating")}
    </span>
  );
}

export default UpdatingIndicator;
